import whatsappBranches from "./whatsappBranches.json";

export const getActiveWhatsAppBranches = () =>
  whatsappBranches.filter((branch) => branch.active);

export const buildWhatsAppUrl = (phone, message = "") => {
  const encodedMessage = encodeURIComponent(message);
  return `https://api.whatsapp.com/send?phone=${phone}&text=${encodedMessage}`;
};

export const getBranchMessage = (branch, defaultMessage = "") => {
  const branchMessage = branch?.message?.trim();

  if (branchMessage && defaultMessage) {
    return `${branchMessage}\n\n${defaultMessage}`;
  }

  if (branchMessage) {
    return branchMessage;
  }

  return defaultMessage;
};

export const openWhatsAppChat = (phone, message = "") => {
  window.open(
    buildWhatsAppUrl(phone, message),
    "_blank",
    "noopener,noreferrer",
  );
};
